import UserGestorService from '@/services/UserGestorService';
import GroupService from '@/services/GroupService';
import AreaService from '@/services/AreaService';
import AreaPermissionService from '@/services/AreaPermissionService';
import RestAuthService from '@/services/RestAuthService';
import types from '@/types';

const createUserModule = (tokenService) => ({
  namespaced: true,
  state: {
    user: {
      pk: '',
      full_name: '',
      email: '',
      groups: [],
      username: '',
      is_active: true,
    },
    users: [],
    areas: [],
    areas_selected: [],
    groups: [],
    totalUsers: 0,
    applications: [process.env.APPLICATION_ID],
    userStatus: [
      { id: 2, name: 'Todos' },
      { id: 1, name: 'Activo' },
      { id: 0, name: 'Inactivo' },
    ],
  },

  mutations: {
    [types.SET_USER](state, user) {
      state.user = user;
    },
    [types.SET_USERS](state, users) {
      state.users = users;
    },
    [types.SET_GROUPS](state, groups) {
      state.groups = groups;
    },
    [types.SET_AREAS](state, areas) {
      state.areas = areas;
    },
    [types.SET_AREAS_SELECTED](state, areas) {
      state.areas_selected = areas;
    },
    SET_TOTAL_USERS(state, totalUsers) {
      state.totalUsers = totalUsers;
    },
  },

  actions: {
    [types.LOGIN]({ dispatch }, data) {
      return tokenService.login(data)
        .then((response) => {
          const token = response.data;
          localStorage.setItem('token', token.access);
          localStorage.setItem('refresh', token.refresh);
          return dispatch(types.GET_USER);
        });
    },
    [types.LOGOUT]() {
      delete localStorage.token;
      delete localStorage.refresh;
      return new Promise((resolve) => {
        resolve();
      });
    },
    [types.REFRESH_TOKEN]({ dispatch }, refresh) {
      return tokenService.refresh({ refresh })
        .then((response) => {
          const token = response.data;
          localStorage.setItem('token', token.access);
          localStorage.setItem('refresh', token.refresh);
          return dispatch(types.GET_USER);
        })
        .catch(() => {
          dispatch(types.LOGOUT);
          throw new Error('Token refresh failed');
        });
    },
    [types.GET_USER]({ commit }) {
      return tokenService.getUserInfo()
        .then((response) => {
          commit(types.SET_USER, response.data);
        });
    },
    [types.GET_USERS]({ commit }, params) {
      const userService = new UserGestorService();
      return userService.getList(params)
        .then((response) => {
          commit(types.SET_USERS, response.data.results);
          commit('SET_TOTAL_USERS', response.data.count);
        });
    },
    [types.GET_USER_GDE]({ commit }, userId) {
      const userService = new UserGestorService();
      return userService.get(userId)
        .then((response) => {
          commit(types.SET_USER, response.data);
        });
    },
    [types.GET_AREAS_USER]({ commit }) {
      const areaService = new AreaService();
      return areaService.getList()
        .then((response) => {
          const areas = response.data;
          commit(types.SET_AREAS, areas);
        });
    },
    [types.GET_AREAS_SELECTED]({ commit, params }) {
      const areaService = new AreaPermissionService();
      return areaService.getList(params)
        .then((response) => {
          const areas = response.data;
          commit(types.SET_AREAS, areas);
        });
    },
    [types.GET_GROUPS]({ commit }) {
      const groupService = new GroupService();
      return groupService.getList()
        .then((response) => {
          const groups = response.data;
          commit(types.SET_GROUPS, groups);
        });
    },
    [types.REQUEST_PASSWORD_RESET](context, passwordResetForm) {
      const restAuthService = new RestAuthService();
      return restAuthService.requestPasswordReset(passwordResetForm);
    },
    [types.RESET_PASSWORD](context, passwordResetForm) {
      const restAuthService = new RestAuthService();
      return restAuthService.resetPassword(passwordResetForm);
    },
    [types.CREATE_USER](context, userForm) {
      const userService = new UserGestorService();
      return userService.create(userForm);
    },
    [types.UPDATE_USER](context, userForm) {
      const userId = userForm.id;
      const userService = new UserGestorService();
      return userService.update(userId, userForm);
    },
    [types.FAST_PASSWORD_RESET](context, passwordResetForm) {
      const userService = new UserGestorService();
      return userService.fastPasswordReset(passwordResetForm);
    },
    [types.RESET_MY_PASSWORD](context, resetMyPasswordForm) {
      const userService = new UserGestorService();
      return userService.resetMyPassword(resetMyPasswordForm);
    },
    async [types.SETUP_CREATE_USER]({ dispatch }) {
      await dispatch(types.GET_GROUPS);
      await dispatch(types.GET_AREAS_USER);
    },
    async [types.SETUP_UPDATE_USER]({ dispatch }) {
      await dispatch(types.GET_GROUPS);
      await dispatch(types.GET_AREAS_USER);
      await dispatch(types.GET_AREAS_SELECTED);
    },
  },
});

export default createUserModule;



// WEBPACK FOOTER //
// ./src/store/modules/user.js